import { AddIcon } from '@chakra-ui/icons';
import { Button, Flex, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

interface NoResourceFoundProps {
  resourceType: 'practices' | 'providers' | 'markets' | 'plans';
  showAddButton?: boolean;
  isAdmin?: boolean;
}

const resourceMeta = {
  practices: {
    title: 'No practices',
    subtitle: 'There is no associated practices with this resource.',
    path: '/practices/create',
  },
  providers: {
    title: 'No providers',
    subtitle: 'There is no associated providers with this resource.',
    path: '/providers/create',
  },
  markets: {
    title: 'No markets',
    subtitle: 'There is no associated markets with this resource.',
    path: '/markets/create',
  },
  plans: {
    title: 'No plans',
    subtitle: 'There is no associated plans with this resource.',
    path: '/plans/create',
  },
};

const NoResourceFound: React.FC<NoResourceFoundProps> = ({
  resourceType,
  showAddButton = true,
  isAdmin = true,
}) => {
  const navigate = useNavigate();
  const { title, subtitle, path } = resourceMeta[resourceType];

  return (
    <Flex
      bg="blue.100"
      borderRadius="lg"
      height={'18.1875rem'}
      width="100%"
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Text
        fontSize="1.25rem"
        fontWeight="700"
        lineHeight="1.75rem"
        color="black"
      >
        {title}
      </Text>
      <Text
        fontSize="1rem"
        fontWeight="500"
        lineHeight="1.5rem"
        color="black"
        mt="0.95rem"
      >
        {subtitle}
      </Text>
      {showAddButton && (
        <Button
          colorScheme="blue"
          background="background.brandLight"
          leftIcon={<AddIcon />}
          size="md"
          px={6}
          py={3}
          mt="1.25rem"
          onClick={() => navigate(path)}
          isDisabled={!isAdmin}
        >
          Add Resource
        </Button>
      )}
    </Flex>
  );
};

export default NoResourceFound;
